import Input from "components/Elements/Input";
const NumberField = ({ name, param, value, onChange = () => {} }) => {
  return (
    <>
      <Input type="number" name={name} value={value} onChange={onChange} />
    </>
  );
};

export default NumberField;
